import React from 'react';
import Container from '../../../containers/system/logs/showLogContainer';

export default function () {
  return (
    <Container />
  );
}
